import { CLOUD_DVIR_TAG } from '../Constants';

class LogRequest {
  readonly dataModelNumber: number = 1;

  tag: string;

  level: string;

  objects: unknown[];

  constructor(level: string, objects: unknown[]) {
    this.tag = CLOUD_DVIR_TAG;
    this.level = level;
    this.objects = objects;
  }
}

export default LogRequest;
